import { Link } from '@tanstack/react-router';

import { Fund } from '~/types';

export function FundLinkCell(props: { value: string; data: Fund }) {
  if (!props.value) {
    return '-';
  }
  return (
    <Link
      color="info"
      className="underline-on-hover"
      to={`/documents/fund/${props.data.fundId}`}
    >
      {props.value}
    </Link>
  );
}
